import React, { Component, Fragment } from 'react'
import { Card, Alert, Progress, Button, Badge, UncontrolledTooltip } from 'reactstrap'
import "./DocumentListNew.css"
import DocumentModalNew from "./DocumentModalNew"
import { CarDocumentsQuery, DriverDocumentsQuery } from "./Quries"

import { graphql } from '@apollo/client/react/hoc'
import { Query } from '@apollo/client/react/components'

import withApolloClient from '../../withApolloClient'
import DatetimeRenderer from "../DatetimeRenderer"
import { ReactComponent as DocVerified } from "../../assets/images/icons/doc-verified.svg"
import { HasPermissionsQuery } from "../../Functions/querys"
import { isImage, isPdf, isVideo, isSpreadsheet, getOfficeViewerUrl, cleanDocumentUrl } from "./utils"

class DocumentsListNew extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            selectedDocument: null,
            previewUrls: {},
            heicUnsupported: {}
        }
    }
    async componentDidMount() {
        await this.prepareHeicPreview()
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.documents !== this.props.documents) {
            await this.prepareHeicPreview()
        }
    }

    next = () => {
        const { documents } = this.props
        const currentIndex = documents.findIndex(item => item.id === this.state.selectedDocument.id)
        if (currentIndex === documents.length - 1) return
        this.setState({ selectedDocument: documents[currentIndex + 1] })
    }

    prev = () => {
        const { documents } = this.props
        const currentIndex = documents.findIndex(item => item.id === this.state.selectedDocument.id)
        if (currentIndex === 0) return
        this.setState({ selectedDocument: documents[currentIndex - 1] })
    }
    fetchMetaData = (metadata = null, name) => {
        if (!metadata || metadata === "")
            return null
        try {
            metadata = JSON.parse(metadata.replace(/'/g, '"').replace(/True/g, 'true').replace(/False/g, 'false'))
        } catch (error) {
            metadata = null
        }
        return metadata && metadata[name] ? metadata[name] : null
    }


    getDisplayUrl = async (fileUrl) => {
        try {
            const res = await fetch(fileUrl)
            const blob = await res.blob()

            const isHeic =
                blob.type.includes("heic") ||
                blob.type.includes("heif") ||
                blob.type === "application/octet-stream"

            // Safari supports HEIC, Chrome does not
            const isSafari = /^((?!chrome|android).)*safari/i.test(
                navigator.userAgent
            )

            if (isHeic && !isSafari) {
                const heic2any = (await import("heic2any")).default
                const convertedBlob = await heic2any({
                    blob,
                    toType: "image/jpeg",
                    quality: 0.8,
                })

                return URL.createObjectURL(convertedBlob) // Preview URL
            }

            return URL.createObjectURL(blob) // Normal image
        } catch (err) {
            console.error("HEIC conversion failed:", err)
            return fileUrl // fallback
        }

    }

    isHeic = (name = "") => {
        return /\.(heic|heif|octet-stream)$/i.test(name)
    };

    convertHeicToJpeg = async (fileUrl, docId) => {
        try {
            const response = await fetch(fileUrl)
            const blob = await response.blob()

            const heic2any = (await import("heic2any")).default
            const outputBlob = await heic2any({
                blob: blob,
                toType: "image/jpeg",
                quality: 0.8
            })

            return URL.createObjectURL(outputBlob)
        } catch (err) {
            console.error("HEIC conversion failed:", err)
            this.setState(prev => ({ heicUnsupported: { ...prev.heicUnsupported, [docId]: true } }))
            return null
        }
    };

    prepareHeicPreview = async () => {
        const previewUrls = { ...this.state.previewUrls }

        for (let doc of this.props.documents) {
            if (!doc) continue
            if (!this.isHeic(doc.name)) continue
            if (previewUrls[doc.id]) continue

            const convertedUrl = await this.convertHeicToJpeg(doc.documentUrl, doc.id)

            if (convertedUrl) {
                previewUrls[doc.id] = convertedUrl
            }
        }

        this.setState({ previewUrls })
    };

    render() {
        let { documents, loading, hasNextPage, loadMore } = this.props
        if (!documents || documents.length === 0) {
            return loading ? <Progress animated color="info" value="100">Loading Documents...</Progress> : (
                <div className="DocumentsEmptyState">
                    <i className="fa fa-file-text-o DocumentsEmptyStateIcon" aria-hidden="true" />
                    <div className="DocumentsEmptyStateTitle">No Documents Found</div>
                    <p className="DocumentsEmptyStateDescription mb-0">No documents have been uploaded yet.</p>
                </div>
            )
        }
        return (
            <Fragment>
                <div className="DocumentCardContainer document-cards-theme">
                    {this.state.selectedDocument &&
                        <DocumentModalNew
                            document={this.state.selectedDocument}
                            handleClose={() => this.setState({ selectedDocument: null })}
                            next={this.next}
                            prev={this.prev}
                            objectType={this.props.objectType}
                            refetch={this.props.refetch}
                            currentUser={this.props.currentUser}
                            driverId={this.props.driverId}
                        />
                    }
                    {documents.map((document, index) =>
                        <Card className="DocumentCard" key={index}>
                            <div className="DocumentCardHeader" onClick={() =>
                                this.setState({
                                    selectedDocument: {
                                        ...document,
                                        documentUrl: this.state.previewUrls?.[document.id] || document.documentUrl,
                                        __isConvertedPreview: !!this.state.previewUrls?.[document.id],
                                    },
                                })
                            }>
                                <p className="DocumentCardTitle">
                                    <span><i className={document.name && document.name.toUpperCase().slice(-4) === ".PDF" ? "fa fa-file-pdf-o" : isSpreadsheet("", document.name) ? "fa fa-file-excel-o" : "fa fa-picture-o"} aria-hidden="true"></i></span>&nbsp;&nbsp;
                                    <span>
                                        {document.documentType ? document.documentType.typeName : document.name}
                                        &nbsp;
                                        {
                                            this.props.verification?.documentData?.map((item, index) => {
                                                if (item.documentName === document.documentType.typeName) {
                                                    if (item.isVerified === false) {
                                                        return (
                                                            <>
                                                                <UncontrolledTooltip target="verified">Document info incomplete</UncontrolledTooltip>
                                                                {this.fetchMetaData(document.metadata, "verified_by") != "System" ? <DocVerified id="verified" width="20" height="20" className="document_verified fa fa-check-circle" fill="red" /> : <i id="verified" className="document_verified fa fa-cross-circle my-2" style={{ color: "red" }}></i>}
                                                            </>
                                                        )
                                                    } else {
                                                        return (
                                                            <></>
                                                        )
                                                    }
                                                }
                                            })
                                        }

                                        {document.isVerified && <>
                                            <UncontrolledTooltip target="verified">{"Verified By " + (this.fetchMetaData(document.metadata, "verified_by") || "System")}</UncontrolledTooltip>
                                            {this.fetchMetaData(document.metadata, "verified_by") != "System" ? <DocVerified id="verified" width="20" height="20" className="fa fa-check-circle" fill="green" /> : <i id="verified" className="fa fa-check-circle" style={{ color: "green" }}></i>}
                                        </>}
                                    </span>
                                </p>
                                <p><i className="fa fa-arrows-alt"></i></p>
                            </div>
                            <div className="DocumentCardPreview">
                                {document && document.documentUrl ? (
                                    this.isHeic(document.name) ? (
                                        this.state.previewUrls[document.id] ? (
                                            // <p>heic</p>
                                            <img
                                                className="DocumentCardPreviewEmbed DocViewerImage"
                                                src={this.state.previewUrls[document.id]}
                                                alt="HEIC Preview"
                                            />
                                        ) : this.state.heicUnsupported[document.id] ? (<div className="heic-unsupported-message"><i className="fa fa-image" /><p>HEIC preview not supported in this browser</p></div>)
                                            : (
                                                <div style={{ padding: "20px" }}>Loading…</div>
                                            )
                                    ) : isImage(document.documentUrl, document.name) ? (
                                        // <p>jpeg</p>
                                        <img
                                            className="DocumentCardPreviewEmbed DocViewerImage"
                                            src={document.documentUrl}
                                            alt="Document"
                                        />
                                    ) : isVideo(document.documentUrl, document.name) ? (
                                        <video
                                            className="DocumentCardPreviewEmbed DocViewerVideo"
                                            src={document.documentUrl}
                                            controls
                                            playsInline
                                            preload="metadata"
                                        />
                                    ) : isPdf(document.documentUrl, document.name) ? (
                                        // <p>pdf</p>
                                        <iframe
                                            scrolling="no"
                                            className="DocumentCardPreviewEmbed"
                                            src={document.documentUrl}
                                            title="PDF Preview"
                                        />

                                    ) : isSpreadsheet(document.documentUrl, document.name) ? (
                                        <iframe
                                            className="DocumentCardPreviewEmbed"
                                            src={getOfficeViewerUrl(document.documentUrl)}
                                            title="Spreadsheet Preview"
                                        />
                                    ) : (
                                        <div className="DocumentCardPreviewEmbed d-flex align-items-center justify-content-center">
                                            <div className="text-center px-2">
                                                <i className="fa fa-file-text-o fa-2x mb-2" aria-hidden="true" />
                                                <div>Preview isn't available here. Click expand icon to view or download the document.</div>
                                            </div>
                                        </div>
                                    )
                                ) : null}
                            </div>

                            <div className="DocumentCardFooter" onClick={() => this.setState({ selectedDocument: document })}>
                                <div className="DocumentCardMeta">
                                    <i className="fa fa-clock-o" aria-hidden="true" />&nbsp;
                                    Uploaded {document.dateAdded ? <DatetimeRenderer datetime={document.dateAdded} /> : "--"}
                                </div>
                                <div>
                                    {document.isArchived && <Badge color="danger" className="mr-1">Archived</Badge>}
                                    {document.isExpired ?
                                        <Badge color="danger">Expired on <DatetimeRenderer datetime={document.expiration} /></Badge>
                                        :
                                        document.expiration ?
                                            <Badge>Expires on <DatetimeRenderer datetime={document.expiration} /></Badge>
                                            :
                                            ""
                                    }
                                </div>
                            </div>
                        </Card>

                    )}
                </div >
                {hasNextPage && loadMore && <Button className="btn btn-primary" onClick={() => loadMore()}>Load more</Button>}
            </Fragment>
        )
    }
}

const cleanGDriveURl = (url, name) => {
    if (isImage(url, name)) {
        if (!(url.includes("/d/") || url.includes("uc?id=")))
            return url
        let id = url.includes("/d/") ? url.split("/d/")[1] : url.split("uc?id=")[1]
        id = id.includes("&export=download") ? id.replace("&export=download", "") : id.split("/view")[0]
        url = "https://drive.google.com/thumbnail?id=" + id + "&sz=w1000"
    } else {
        if (url.includes("&export=download")) {
            url = "https://drive.google.com/file/d/" + url.split("uc?id=")[1].replace("&export=download", "/preview?usp=drivesdk")
        } else {
            url = url.replace("view", "preview")
        }
    }
    url = url.replace('%2F', '/')
    url = url.replace('&export=download', '')
    return url
}

const isHeicFile = (name = "", url = "") => {
    return /\.(heic|heif|octet-stream)$/i.test(name) || /\.(heic|heif|octet-stream)$/i.test(url)
}


// ############################################DRIVER DOCUMENTS #######################################

class DriverDocumentsList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            selectedDocument: null,
        }
    }



    render() {
        const objectType = "driver"
        return (
            <Query
                query={DriverDocumentsQuery}
                variables={{
                    first: 10,
                    orderBy: ["-date_added"],
                    categoriesIn: this.props.categoriesIn,
                    filters: [
                        ...(this.props.driverId ? [{ fieldName: "driver", filterType: "equal", filterValues: this.props.driverId }] : []),
                        ...(this.props.typesIn && this.props.typesIn.length > 0 ? [{ fieldName: "document_type", filterType: "in", filterValues: this.props.typesIn }] : []),
                        ...(typeof this.props.isArchived === "boolean" ? [{ fieldName: "is_archived", filterType: "equal", filterValues: this.props.isArchived }] : []),
                        ...(this.props.filters || []),
                    ],
                }}
                fetchPolicy='cache-and-network'>
                {({ loading, error, data, fetchMore, refetch }) =>
                    <DocumentsListNew
                        documents={data && data.documents && data.documents.edges && data.documents.edges.length > 0 ? data.documents.edges.map(item => ({
                            ...item.node, documentUrl: item?.node?.documentUrl?.includes("drive.google") ? cleanGDriveURl(item.node.documentUrl, item.node.name) : isHeicFile(item.node?.name) ? item.node.documentUrl : item.node?.documentUrl ? cleanDocumentUrl(item.node.documentUrl) : ""
                        })) : []}
                        currentUser={this.props.currentUser}
                        verification={this.props.driverDocVerification}
                        loading={loading}
                        refetch={refetch}
                        objectType={objectType}
                        driverId={this.props.driverId}
                        hasNextPage={data && data.documents && data.documents.pageInfo && data.documents.pageInfo.hasNextPage}
                        loadMore={() => fetchMore({
                            variables: {
                                cursor: data.documents.pageInfo.endCursor,
                            },
                            updateQuery: (prev, { fetchMoreResult }) => {
                                if (!fetchMoreResult) return prev
                                return Object.assign({}, prev, {
                                    documents: {
                                        ...prev.documents,
                                        edges: [...prev.documents.edges, ...fetchMoreResult.documents.edges],
                                        pageInfo: fetchMoreResult.documents.pageInfo,
                                    }
                                })
                            }
                        })}
                    />
                }
            </Query>
        )
    }
}

// ############################################ CAR DOCUMENTS #######################################

class CarDocuments extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal: false,
            selectedDocument: null,
            hasTlcPermissions: true,
            loading: true
        }
    }

    componentDidMount() {
        const { apolloClient } = this.props
        this.props.apolloClient.query({
            query: HasPermissionsQuery,
            variables: { userPermissions: ["custom_can_view_tlc_docs"] }
        }).then(res => {
            this.setState({ hasTlcPermissions: res.data.hasPermissions, loading: false })
        })
    }

    render() {
        const objectType = "car"
        return (
            <div>
                <Alert color="info">For car registrations, please visit <a href={`${process.env.REACT_APP_FLEETSYNC_URL}/cars/${this.props.carPk || ''}`} target="_blank">Fleetsync</a>.</Alert>
                {!this.state.loading && <Query
                    query={CarDocumentsQuery}
                    variables={{ id: this.props.carId, categoriesIn: this.props.categoriesIn, typesIn: this.props.typesIn, isDeleted: this.props.isArchived, first: 9, orderBy: ["-id"] }}
                    fetchPolicy='cache-and-network'
                    skip={!this.props.carId}
                >
                    {({ loading, error, data, fetchMore, refetch }) =>
                        <DocumentsListNew
                            documents={data && data.documents && data.documents.edges && data.documents.edges.length > 0 ? data.documents.edges.filter(item => item.node.documentType.documentCategory.name !== "TLC" || this.state.hasTlcPermissions).map(item => ({
                                ...item.node, documentUrl: item?.node?.documentUrl?.includes("drive.google") ? cleanGDriveURl(item.node.documentUrl, item.node.name) : isHeicFile(item.node?.name) ? item.node.documentUrl : item.node?.documentUrl ? cleanDocumentUrl(item.node.documentUrl) : ""
                            })) : []}
                            currentUser={this.props.currentUser}
                            loading={loading}
                            refetch={refetch}
                            objectType={objectType}
                            hasNextPage={data && data.documents && data.documents.pageInfo && data.documents.pageInfo.hasNextPage}
                            loadMore={() => fetchMore({
                                variables: {
                                    cursor: data.documents.pageInfo.endCursor,
                                },
                                updateQuery: (prev, { fetchMoreResult }) => {
                                    if (!fetchMoreResult) return prev
                                    return Object.assign({}, prev, {
                                        documents: {
                                            ...prev.documents,
                                            edges: [...prev.documents.edges, ...fetchMoreResult.documents.edges],
                                            pageInfo: fetchMoreResult.documents.pageInfo,
                                        }
                                    })
                                }
                            })}
                        />
                    }
                </Query>}
            </div>
        )
    }
}

const CarDocumentsList = withApolloClient(CarDocuments)

export { DriverDocumentsList, CarDocumentsList, DocumentsListNew, cleanDocumentUrl, isImage, isVideo, isHeicFile }
